import React from 'react';

const Introduce = () => {
  return (
    <section className='bg-light page-section' id='introduce'>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-12 text-center'>
            <h2 className='section-heading'>Woojin Oh</h2>
            <h3 className='section-subheading text-muted'>
              <span className='yellow'>A</span>
              <span className='yellowOrange'>W</span>
              <span className='orange'>E</span>
              <span className='red'>S</span>
              <span className='redPink'>O</span>
              <span className='pink'>M</span>
              <span className='purple'>E </span>
              Web Developer <br />
              and <br />
              <span className='coffee1'> C</span>
              <span className='coffee2'>o</span>
              <span className='coffee3'>f</span>
              <span className='coffee4'>f</span>
              <span className='coffee3'>e</span>
              <span className='coffee1'>e </span>
              Lover
            </h3>
          </div>
        </div>
        <div className='row text-center justify-content-center'>
          <div className='col-md-9'>
            <p className='text-muted'>
              Hard-working web developer with a passion for creating best
              solutions in the least amount of time. Modesty and constant effort
              are the motto of my life. According to the motto of my life, I
              constantly analyze problems and try to come up with better ways
              when faced with problems or challenges.
            </p>
            <p className='text-muted font-weight-bold'>
              Web developing with coffee is my best pleasure.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Introduce;
